import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import MuiLink from '@mui/material/Link'
import { AGENT_BILL_PAY_PATH } from '@pages/bill-pay/constants'
import { isInIframe } from '@utils/is-in-iframe'
import { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'

import { CrumbLabel } from './crumb-label'

export const Breadcrumbs = () => {
  const { pathname, state } = useLocation()

  const [history, setHistory] = useState([])

  useEffect(() => {
    setHistory((prev) => {
      if (pathname === '/') {
        return []
      }

      if (pathname === '/ask-ai') {
        return ['/ask-ai']
      }

      if (state?.addToHistory === false) {
        return prev
      }

      if (prev[prev.length - 1] === pathname) {
        return prev
      }

      return [...prev, pathname]
    })
  }, [pathname, state])

  if (
    pathname === '/' ||
    pathname.startsWith('/ask-ai') ||
    pathname.startsWith(AGENT_BILL_PAY_PATH)
  ) {
    return null
  }

  return (
    <MuiBreadcrumbs
      maxItems={3}
      itemsBeforeCollapse={history.includes('/ask-ai') ? 2 : 1}
      itemsAfterCollapse={1}
      aria-label="breadcrumbs-history"
      sx={{
        flexShrink: 0,
        px: { xs: 0, md: 3 },
        pt: { xs: 0, md: 2 },
      }}
    >
      {!isInIframe && (
        <MuiLink
          to="/"
          underline="hover"
          component={Link}
          sx={{
            color: 'primary.main',
            '&:active': {
              color: 'primary.light',
              textDecoration: 'none',
            },
            '&:hover': {
              color: 'primary.light',
              textDecoration: 'none',
            },
          }}
        >
          Documents repository
        </MuiLink>
      )}

      {history.map((path, index) => {
        const label = path.split('/').findLast(Boolean)

        return (
          <MuiLink
            key={index}
            to={path}
            component={Link}
            state={{ addToHistory: false }}
            underline="hover"
            sx={{
              color: 'primary.main',
              '&:active': {
                color: 'primary.light',
                textDecoration: 'none',
              },
              '&:hover': {
                color: 'primary.light',
                textDecoration: 'none',
              },
            }}
          >
            <CrumbLabel docId={label} />
          </MuiLink>
        )
      })}
    </MuiBreadcrumbs>
  )
}
